import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    button: 'mb-5 w-full',
    disclaimer: 'heading-xs text-secondary-hover-light',
    link: 'underline underline-offset-4'
  }
});
